<template src="./column-title.html"></template>
<script>

export default {
    name: 'ColumnTitle',
    props: {
        column: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        title() {
            return this.column.name;
        },
        region() {
            return this.column?.data?.region;
        },
    }
};

</script>

<style lang="scss" scoped>
.title {
    &__region {
        color: grey;
    }
}
</style>
